import { Helmet } from "react-helmet-async"
import { Loader2 } from "lucide-react"

import { useGetAllTraitsQuery } from "@apis/traits/useTraits"
import { useHasPermissions } from "@hooks/useHasPermissions"

import { ManualUploadForm } from "./ManualUploadForm"
import { FileUploadForm } from "./FileUploadForm"

const BulkAddTraits = () => {
  const { canBulkAddTraits } = useHasPermissions()
  const getAllTraits = useGetAllTraitsQuery()

  const renderContent = () => {
    if (!canBulkAddTraits)
      return <div>You do not have permission to bulk add traits.</div>

    if (getAllTraits.isPending)
      return (
        <Loader2 className="tw:h-6 tw:w-6 tw:animate-spin tw:text-gray-500" />
      )

    if (getAllTraits.isError)
      return (
        <div className="tw:text-red-500">
          There was an error loading traits. Error: {getAllTraits.error.message}
        </div>
      )

    return (
      <>
        <ManualUploadForm traits={getAllTraits.data} />
        <FileUploadForm traits={getAllTraits.data} />
      </>
    )
  }

  return (
    <>
      <Helmet title="Bulk Add Traits" />
      <div className="tw:flex tw:flex-col tw:gap-6 tw:p-6">
        <h1 className="tw:text-3xl tw:font-bold">Bulk Add Traits</h1>
        {renderContent()}
      </div>
    </>
  )
}

export default BulkAddTraits
